import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { ShareCta } from './ShareCta';
import { ShowMoreCta } from './ShowMoreCta/ShowMoreCta';
import { EditGigCta } from './EditGigCta';

interface ActionCtasProps {
  CollectionCta: React.FC;
}

export const ActionCtas: React.FC<ActionCtasProps> = ({ CollectionCta }) => {
  const { isPageOwner } = useGigPageContext();

  return (
    <Stack justifyContent="flexEnd">
      {isPageOwner ? (
        <EditGigCta />
      ) : (
        <>
          <CollectionCta />
          <ShareCta />
          <ShowMoreCta />
        </>
      )}
    </Stack>
  );
};
